<template>
  <div class="check-list" ref="containerRef">
    <search :formModel="formModel" :formButton="formButton" :deviceModelBusiType="12"></search>
    <m-table
      i18n-path="query"
      :loading="loading"
      :tableData="formatHisData"
      :tableColumn="tableColumn"
      :oprateMenu="oprateMenu"
      :pagiOption="pagiOption"
      :span-method="spanMethod"
      v-on:search="search"
    ></m-table>
  </div>
</template>

<script>
import { merge } from 'lodash';
import { getEFM100CheckList } from '@/api/query';
import { formatTimestamp, downFile, dayTime } from '@/utils/utils';
import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';

export default {
  name: 'checkList',
  props: {
    sn: String
  },
  components: { Search, MTable },
  data() {
    return {
      hisData: [],
      loading: true,
      currentRamanSpectrumOptions: {},
      formModel: {
        sn: this.sn ? [this.sn] : [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()],
        deviceModel: []
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '设备名', prop: 'deviceName' },
        { label: '设备类型', prop: 'deviceType', width: '140px' },
        { label: '检测结果', prop: 'testResult' },
        {
          label: '检测时间',
          prop: 'beginTime',
          temp: scope => {
            return `<span>${formatTimestamp(scope.row.beginTime)}</span>`;
          }
        },
        {
          label: '检测结束时间',
          prop: 'endTime',
          temp: scope => {
            return `<span>${formatTimestamp(scope.row.endTime)}</span>`;
          }
        },
        {
          label: '备注',
          prop: 'remarks'
        }
      ],
      oprateMenu: {
        label: '操作',
        width: '259px',
        list: [
          {
            text: '详情',
            access: () => {
              return this.authMenu['010501'];
            },
            event: (_index, data) => {
              this.$router.push({
                path: `/query/efm100-checkdetail/${data.testId}/${data.deviceType}`
              });
            }
          }
        ]
      },
      formButton: [
        {
          text: '查询',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        },
        {
          text: '导出',
          code: '010721',
          loading: false,
          event: this.hisExport
        }
      ]
    };
  },
  computed: {
    formatHisData() {
      const arr = [];

      this.hisData.forEach(h => {
        if (!h.materials) {
          arr.push(h);
        } else {
          h.materials.forEach((m, i) => {
            const item = { ...h, ...m, spanMerge: i === 0 ? [h.materials.length, 1] : [0, 0] };
            delete item.materials;
            arr.push(item);
          });
        }
      });
      return arr;
    },
    comParams() {
      const { formModel, pagiOption } = this;
      return merge(
        {
          beginTime: formModel.rangeDateVal && formModel.rangeDateVal[0],
          endTime: formModel.rangeDateVal && formModel.rangeDateVal[1],
          limit: pagiOption.limit,
          offset: pagiOption.offset
        },
        formModel
      );
    }
  },
  methods: {
    langChangeHandler() {
      this.search();
    },
    formatTimestamp,
    search() {
      this.loading = true;
      getEFM100CheckList(this.comParams)
        .then(res => {
          this.hisData = res.data.list;
          this.pagiOption.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    spanMethod({ row, column }) {
      if (column.property !== 'typeName' && column.property !== 'materialName') {
        return row.spanMerge;
      }
    },
    hisExport(op) {
      op.loading = true;
      downFile({
        url: '/devicedata/exportHisDetectExplosionive',
        method: 'post',
        data: this.comParams
      }).finally(() => {
        op.loading = false;
      });
    },
    resetSearch() {
      const newData = this.$options.data.call(this);
      this.hisData.splice(0);
      Object.assign(this.formModel, newData.formModel);
      Object.assign(this.pagiOption, newData.pagiOption);
    }
  },
  watch: {
    sn: {
      handler(n, o) {
        if (n !== o) this.resetSearch();
        this.search();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.check-list {
  padding: 10px;
  box-sizing: border-box;
}
</style>
